import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const priceTitleId = 'PriceInfoBlock-priceTitle';
const priceToPayId = 'PriceInfoBlock-priceToPay';

export const usePriceInfoBlock = (price: string) => {
	const { t } = useTranslation('dticket');

	return useMemo(
		() => ({
			priceTitleId,
			priceToPayId,
			priceTitle: t('label.price_per_month'),
			priceToPayText: t('text.price_per_month', { price }),
		}),
		[price, t]
	);
};
